import {useDebounce, ApplicationController} from "stimulus-use";

export default class extends ApplicationController {
  static debounces = [ 'search' ];
  static targets = [ 'checkbox', 'chips', 'chipTemplate', 'searchInput', 'option' ];
  static values = { id: String };
  declare readonly idValue: string;
  declare readonly checkboxTargets: HTMLInputElement[];
  declare readonly chipsTarget: HTMLDivElement;
  declare readonly searchInputTarget: HTMLInputElement;
  declare readonly chipTemplateTarget: HTMLTemplateElement;
  declare readonly optionTargets: HTMLLIElement[];

  connect() {
    useDebounce(this, { wait: 300 });
  }

  disconnect() {
    if (this.dropdownInstance) this.dropdownInstance.destroyAndRemoveInstance();
  }

  get selectedValues(): { value: string; label: string }[] {
    return this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => ({ value: checkbox.value, label: checkbox.dataset.label }));
  }

  get dropdownInstance() {
    return window.FlowbiteInstances.getInstance('Dropdown', this.idValue);
  }

  change = e => {
    this.chipsTarget.innerHTML = '';
    this.selectedValues.forEach(({ value, label }) => {
        const chip = this.chipTemplateTarget.content.cloneNode(true) as HTMLElement;
        chip.querySelector('.chip-text').textContent = label;
        this.chipsTarget.appendChild(chip);
    });
    if (this.selectedValues.length) this.chipsTarget.classList.remove('hidden');
    else this.chipsTarget.classList.add('hidden');

    const form = this.element.closest('form');
    if (!!form) form.requestSubmit();
  }

  search = () => {
    const q = (this.searchInputTarget.value ?? '').trim().toLowerCase();
    if (!q.length) return this.optionTargets.forEach(option => option.classList.remove('hidden'));
    this.optionTargets.forEach(option => {
      const { searchLabel } = option.dataset;
      if (!searchLabel?.length) return;
      if (searchLabel.toLowerCase().includes(q)) option.classList.remove('hidden');
      else option.classList.add('hidden');
    });
  }

  clearSearch = e => {
    this.searchInputTarget.value = '';
    this.search();
  }

  clearAll = e => {
    this.checkboxTargets.forEach(checkbox => checkbox.checked = false);
    if (this.dropdownInstance) this.dropdownInstance.hide();
    this.change(e);
  }
}
